/* ae-first-touch.js — ads-expert first-touch capture → Klaviyo ae_ft_* properties.
 * Spec: ads-expert docs/superpowers/specs/2026-09-07-lead-value-design.md §4.
 * Write-once per browser (90 days). Never throws. Only ae_ft_* keys are written. */
(function () {
  'use strict';
  var VERSION = '1.0.0';
  var KEY = 'ae_ft_v1';
  var TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var CLICK_KEYS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid'];
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var OWN_HOSTS = ['bagby.co', 'www.bagby.co', 'bagby-digital-wellbeing.myshopify.com'];

  function safeStorage() {
    try { var t = '__ae_t'; localStorage.setItem(t, '1'); localStorage.removeItem(t); return localStorage; } catch (e) { return null; }
  }
  function readRecord(store) {
    try { var raw = store.getItem(KEY); if (!raw) return null; var r = JSON.parse(raw);
      if (!r || r.v !== 1 || typeof r.ts !== 'string') return null;
      if (Date.parse(r.ts) + TTL_MS < Date.now()) return null; return r; } catch (e) { return null; }
  }
  function referrerHost() {
    try { if (!document.referrer) return ''; var h = new URL(document.referrer).hostname.toLowerCase();
      return OWN_HOSTS.indexOf(h) === -1 ? h : ''; } catch (e) { return ''; }
  }
  function captureIfAbsent(store) {
    if (readRecord(store)) return;
    var q = new URLSearchParams(location.search);
    var rec = { v: 1, ts: new Date().toISOString(), landing_page: (location.pathname + location.search).slice(0, 1000) };
    for (var i = 0; i < CLICK_KEYS.length; i++) { var v = q.get(CLICK_KEYS[i]); if (v) { rec.click_id = v; rec.click_id_type = CLICK_KEYS[i]; break; } }
    for (var j = 0; j < UTM_KEYS.length; j++) { var u = q.get(UTM_KEYS[j]); if (u) rec[UTM_KEYS[j]] = u; }
    var ref = referrerHost(); if (ref) rec.referrer = ref;
    try { store.setItem(KEY, JSON.stringify(rec)); } catch (e) { /* quota — no-op */ }
  }
  function props(rec, surface) {
    var p = { ae_ft_ts: rec.ts, ae_ft_landing_page: rec.landing_page, ae_ft_capture_surface: surface, ae_ft_snippet_version: VERSION };
    if (rec.click_id) { p.ae_ft_click_id = rec.click_id; p.ae_ft_click_id_type = rec.click_id_type; }
    for (var j = 0; j < UTM_KEYS.length; j++) { if (rec[UTM_KEYS[j]]) p['ae_ft_' + UTM_KEYS[j]] = rec[UTM_KEYS[j]]; }
    if (rec.referrer) p.ae_ft_referrer = rec.referrer;
    return p;
  }
  function pushIdentify(p) {
    if (window.klaviyo && typeof window.klaviyo.identify === 'function') { window.klaviyo.identify(p); return true; }
    if (window._learnq && typeof window._learnq.push === 'function') { window._learnq.push(['identify', p]); return true; }
    return false;
  }
  // Klaviyo's onsite SDK reassigns window.klaviyo (new bundles load around the
  // moment of form submission, e.g. post_identification_sync/client_identity),
  // so a single identify() call can land on a transitional reference whose
  // write never reaches the profile that ends up created. identify() itself
  // never confirms delivery — it only confirms the function existed — so send
  // it a few times over a short window instead of trusting one call.
  var RETRY_DELAYS_MS = [0, 1000, 3000, 6000, 10000];
  var identifyDone = false;
  function identify(surface) {
    try {
      if (identifyDone) return; var store = safeStorage(); if (!store) return;
      var rec = readRecord(store); if (!rec) return;
      identifyDone = true;
      var p = props(rec, surface);
      RETRY_DELAYS_MS.forEach(function (delay) {
        setTimeout(function () { try { pushIdentify(p); } catch (e) {} }, delay);
      });
    } catch (e) { /* never throw */ }
  }
  try {
    var store = safeStorage(); if (store) captureIfAbsent(store);
    window.addEventListener('klaviyoForms', function (e) {
      try { if (e && e.detail && e.detail.type === 'submit') identify('klaviyo_form'); } catch (err) {}
    });
  } catch (e) { /* never throw */ }
})();
